/**
 * הסיפור שלנו.
 *
 * NOTHING HERE IS WRITTEN, AND THAT IS NOT AN OVERSIGHT. This page is about the people who built the
 * product — why they started, what they did before, who it is for. Every sentence of it is a fact
 * only they hold, and this is the one page on the site where invention would be indistinguishable
 * from content. Every other figure on this landing is fetched from the API precisely so the page
 * cannot overstate the product; writing a founding story from nothing would break that rule harder
 * than any number ever could.
 *
 * So the page is BUILT and OFF. Fill `STORY` in and it appears — at its own address, in the nav, and
 * in the footer — with no other change anywhere. Leave it null and the path falls through to the
 * landing, so a visitor never meets a page that is waiting for someone.
 *
 * WHAT IT NEEDS: a title, an opening line, and three or four paragraphs. Rough notes in any language
 * are enough to draft from — what you did before, how you got to tenders, the moment it became worth
 * building, who it is for and who it is not.
 */

export interface Story {
  title: string;
  lede: string;
  /** In order. Each becomes a paragraph. */
  paragraphs: string[];
}

/*
  The cast is load-bearing, not decoration: TypeScript narrows a `const` initialised to `null` down
  to the `null` type itself, so every `STORY !== null` branch below would be `never` and would stop
  compiling the moment it touched a field. Declaring the union at the initialiser keeps the guards
  meaningful, and keeps filling this in a one-line edit.
*/
/** The story, once there is one. `null` until then — see above. */
export const STORY = null as Story | null;

/** Whether this page has enough to be worth serving. */
export const storyReady = (): boolean => STORY !== null && STORY.paragraphs.length > 0;

/** Takes the story as a PROP, so the filled-in page is one the suite can render. See ContactPage. */
export function StoryPage({ story }: { story: Story }) {
  return (
    <section className="tenders-band tenders-band-page">
      <div className="tenders-band-wrap">
        <p className="tenders-landing-eyebrow">הסיפור שלנו</p>
        <h1>{story.title}</h1>
        <p className="tenders-landing-lede">{story.lede}</p>
        <div className="tenders-prose">
          {story.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </div>
    </section>
  );
}
